import { useContext, useState, useEffect, useRef } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { Drawer } from '@/components/Common/Drawer';
import { COMPONENT_BY_SCREEN } from '@/constants/ComponentByScreen';
import { cn } from '@/utils/cn';

export const ScreenDrawer = () => {
  const {
    drawer: { closeDrawer, screen },
  } = useContext(CheckoutContext);
  const [displayScreen, setDisplayScreen] = useState(screen);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const previousScreenRef = useRef(screen);

  useEffect(() => {
    if (screen && screen !== previousScreenRef.current && previousScreenRef.current !== undefined) {
      setIsTransitioning(true);

      const timer = setTimeout(() => {
        setDisplayScreen(screen);
        previousScreenRef.current = screen;
        setIsTransitioning(false);
      }, 200);

      return () => clearTimeout(timer);
    } else if (screen) {
      setDisplayScreen(screen);
      previousScreenRef.current = screen;
      setIsTransitioning(false);
    } else if (!screen && displayScreen) {
      // Screen is closing - keep displayScreen for closing animation
      // Clear it after closing animation completes
      const timer = setTimeout(() => {
        setDisplayScreen(undefined);
        previousScreenRef.current = undefined;
      }, 350); // Wait for closing animation to complete (300ms + buffer)
      return () => clearTimeout(timer);
    }
  }, [screen, displayScreen]);

  // Keep Drawer mounted with last screen content to allow closing animation
  if (displayScreen) {
    const Component = COMPONENT_BY_SCREEN[displayScreen];
    return (
      <Drawer isOpen={!!screen} onClose={closeDrawer}>
        <div
          key={displayScreen}
          className={cn('transition-opacity duration-300 ease-in-out', isTransitioning ? 'opacity-0' : 'opacity-100')}
        >
          <Component />
        </div>
      </Drawer>
    );
  }
  return null;
};
